// Sonar/client/ui/UserDashboard.js
import { ComponentBase } from "../core/ComponentBase.js";

export class UserDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-user-dashboard`,
            disableCustomizations: true,
            resizableWidgets: true,
        });
        await super.initialize();
    }

        async initAfterLogin() {
        if (this.dashboardComponent) {
            const predefinedLayout = [
                // Row 1
                { name: 'ActiveMonitorsSummaryWidget', widgetId: 'sonarActiveMonitors', rows: 8, cols: 10 },
                { name: 'RecentAlertsWidget', widgetId: 'sonarRecentAlerts', rows: 8, cols: 20 },

                // Row 2
                { name: 'AlertsByCategoryChartWidget', widgetId: 'sonarAlertsByCategory', rows: 12, cols: 15 },
                { name: 'AnomalyDetectionChartWidget', widgetId: 'sonarAnomalyChart', rows: 12, cols: 15 },

                // Row 3
                { name: 'QuickActionsWidget', widgetId: 'sonarQuickActions', rows: 10, cols: 10 },
                { name: 'RealTimeUsageChartWidget', widgetId: 'sonarRealTimeUsage', rows: 10, cols: 20 },
            ];

            await this.dashboardComponent.setDashboardLayout(predefinedLayout);
        }
    }

    async render() {
        return this.dashboardComponent.render();
    }
}
